module.exports = __webpack_public_path__ + "img/ASO_fr17.cab4df61.png";